import NavigationLinks from './NavigationLinks';
export type {
  NavigationLinksProps,
  NavigationLinkProps
} from './NavigationLinks';
export default NavigationLinks;
